import React, { useEffect, useState } from "react";
import { Formik, Form as FormikForm, Field } from "formik";
import * as Yup from "yup";
import { Form, Button, Row, Col } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../styles/projectDetailForm.css";
import "../../styles/projectsDetails.css";
import {
  lowercaseFirstLetter,
  sortFields,
  parseDate,
} from "./../../services/helper.jsx";
import { useParams } from "react-router-dom";
import SortableHeader from "../fields/SortableHeader.jsx";

import { getProjectQueItems } from "../../services/uiService";
import {
  generateImageString,
  handleDownloadClick,
  resultsFilesDownloadClick,
} from "../../services/helper";
import ModalComponent from "../modal/modalComponent";
import MapiToolbar from "../toolbar/MapiToolbar";

const FormField = ({ field, errors, touched, fieldDataNew }) => (
  <Form.Group
    controlId={field.name}
    className="d-flex fieldWrapper align-items-center custom-no-error-icon mb-3"
  >
    <Form.Label className="dynamicFormTitle">
      {field.label} {field.isRequired && "*"}:
    </Form.Label>
    {field.type === "select" ? (
      <Field
        as="select"
        disabled={field.isDisabled}
        name={field.name}
        // value={fieldDataNew[field.name]}
        className={`form-control d-block text-right ${
          errors[field.name] && touched[field.name]
            ? "custom-invalid-select"
            : field.isDisabled
              ? "disabled-dropdown"
              : "enabled-dropdown"
        }`}
        style={{
          width: "100% !important",
          padding: "0.375rem 0.60rem",
        }}
      >
        {field.options.map((option, index) => (
          <option key={`opt-${index}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </Field>
    ) : field.type === "textarea" ? (
      <Field
        //as="textarea"
        name={field.name}
      >
        {({ field: formikField, meta }) => {
          const dir = /[\u0590-\u05FF]/.test(formikField.value) ? "rtl" : "ltr";
          const textAlign = dir === "rtl" ? "right" : "left";

          return (
            <textarea
              {...formikField}
              disabled={field.isDisabled}
              className={`form-control textarea-form ${
                meta.touched && meta.error ? "is-invalid" : ""
              }`}
              style={{
                background: field.isDisabled ? "#dfe5ee" : "#cddaef",
                direction: dir,
                textAlign: textAlign,
              }}
            />
          );
        }}
      </Field>
    ) : field.type === "number" ? (
      <Field
        disabled={field.isDisabled}
        type="text"
        name={field.name}
        className={`form-control custom-form-control ${
          errors[field.name] && touched[field.name] ? "is-invalid" : ""
        }`}
        pattern="[0-9]*"
        inputMode="numeric"
        onInput={(e) => {
          e.target.value = e.target.value.replace(/[^0-9]/g, "");
        }}
      />
    ) : field?.type === "date" && typeof field.value === "string" ? (
      <Field
        disabled={field.isDisabled}
        type="text"
        name={field.name}
        value={fieldDataNew[field.name]}
        className={`form-control date-text-filter custom-form-control ${
          errors[field.name] && touched[field.name] ? "is-invalid" : ""
        }`}
      />
    ) : field?.type === "date" ? (
      <Field
        disabled={field.isDisabled}
        type="text"
        name={field.name}
        value={fieldDataNew[field.name]}
        className={`form-control date-text-filter custom-form-control ${
          errors[field.name] && touched[field.name] ? "is-invalid" : ""
        }`}
      />
    ) : (
      <Field
        disabled={field.isDisabled}
        type={field.type}
        name={field.name}
        className={`form-control custom-form-control ${
          errors[field.name] && touched[field.name] ? "is-invalid" : ""
        }`}
      />
    )}
  </Form.Group>
);

const FormButtons = ({
  preData,
  values,
  validateForm,
  setTouched,
  onClickSubmitForm,
  onClickCloseForm,
  resetForm,
  isChecked,
  findLastUpdateRecords,
}) => (
  <div className="button-main-wrap pl-1" dir="ltr">
    <div className="button-group main-btn-wrap" dir="rtl">
      <Button
        type="button"
        variant="primary"
        className="maxContentBtn footerbtn primaryBtn"
        size="sm"
        onClick={() => {
          onClickSubmitForm(
            values,
            validateForm,
            setTouched,
            true,
            resetForm,

            preData
          );
        }}
      >
        קליטת תמ"ר לבדיקות
      </Button>
      <Button
        type="button"
        variant="primary"
        className="maxContentBtn footerbtn primaryBtn"
        size="sm"
        onClick={() =>
          onClickSubmitForm(
            values,
            validateForm,
            setTouched,
            false,
            resetForm,
            preData
          )
        }
      >
        שמירת פרוייקט
      </Button>
      <Button
        type="button"
        variant="secondary"
        className="maxContentBtn footerbtn secondaryBtn"
        size="sm"
        onClick={() => onClickCloseForm(resetForm)}
      >
        סגירה
      </Button>
    </div>
    <div className="check-box-wrap">
      <div className="check-box-main">
        <label htmlFor="">הצג עדכון אחרון לכל תמ"ר בלבד</label>
        <input
          type="checkbox"
          value={isChecked}
          name="checkbox"
          id=""
          onChange={findLastUpdateRecords}
        />
      </div>
      {/* <FormCheck type="checkbox" reverse label={'testהצג עדכון אחרון לכל תמ"ר בלבד'} /> */}
    </div>
  </div>
);

const ProjectDetailForm = ({
  preData,
  fields,
  generalEndPoint,
  onClickCloseForm = () => {},
  onClickSubmitForm = () => {},
  onDelete = null,
  isDeleting = false,
}) => {
  const { projectId } = useParams();
  const [isChecked, setIsChecked] = useState(true);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(1);
  const [data, setData] = useState({
    data: [
      {
        batchId: "2fc83d2a-1e93-4aef-b85e-7cd2874f5cbc",
        result: [
          {
            id: 1,
            status: "Success",
            message: "Conversion completed successfully",
          },
          {
            id: 2,
            status: "Failure",
            message: "Error converting file format",
          },
        ],
        batchStartTime: "2025-03-25T10:00:00Z",
        batchEndTime: "2025-03-25T10:05:00Z",
        userId: 1,
        fileId: "abc123",
        excelFileId: "xyz789",
        dwgFileId: "dwg456",
        checkType: "בדיקות המרה",
      },
    ],
  });

  const transformBatchArray = (batchArray) => {
    return batchArray.map((item, index) => ({
      id: index + 1,
      serialNumber: item.batchID,
      date: getProcessNumber(item.result), //,formatDate(item.batchStartTime),
      username: item.userName,
      blockNumber: getGushNumber(item.result),
      actionType: item.checkType,
      startTime: formatTime(item.batchStartTime),
      endTime: formatTime(item.batchEndTime),
      fileId: item.fileID,
      severityStatus: item.severityStatus,
      excelFileId: item.excelFileID,
      dwgFileId: item.dwgFileID,
    }));
  };

  const getProcessNumber = (result) => {
    var processNo = result?.split(", ")[0];
    return processNo?.split(":")[1];
  };
  const getGushNumber = (result) => {
    var gushNo = result?.split(", ")[1];
    return gushNo?.split(":")[1];
  };
  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB").split("/").reverse().join("-"); // Formats as DD-MM-YYYY
  };
  const formatTime = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);

    // Get individual components
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0"); // Ensure two digits
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Ensure two digits

    return `${date.toLocaleDateString("en-GB")} ${hours}:${minutes}`;
  };

  const getAllDatafromSelectedProject = async (projectNumber) => {
    const result = await getProjectQueItems(generalEndPoint, projectNumber);
    if (result.length > 0) {
      const convertedAry = transformBatchArray(result);
      setData(convertedAry);
    }
  };

  const validationSchema = Yup.object().shape(
    fields.reduce((schema, field) => {
      if (field.isRequired) {
        schema[field.name] = Yup.string().required("שדה חובה");
      }
      return schema;
    }, {})
  );
  const initialValues = preData
    ? fields.reduce((values, field) => {
        let key = lowercaseFirstLetter(field.name);
        let value = preData[key];
        if (value !== null && value !== undefined) {
          if (field.type === "date" && typeof value === "string") {
            const dateParts = value.split("-");
            if (dateParts.length === 3) {
              value = value.replace(/-/g, "/");
            }
          }
        } else {
          value = "";
        }
        values[field.name] = value;
        return values;
      }, {})
    : fields.reduce((values, field) => {
        values[field.name] = "";
        return values;
      }, {});

  const columns = 3;
  const rowsPerColumn = Math.ceil(fields.length / columns);
  const fieldGroups = Array.from({ length: columns }, (_, col) =>
    fields.slice(col * rowsPerColumn, (col + 1) * rowsPerColumn)
  );

  const maxRows = Math.max(...fieldGroups.map((group) => group.length));

  fieldGroups.forEach((group) => {
    while (group.length < maxRows) {
      group.push(null);
    }
  });

  const findLastUpdateRecords = (e) => {
    setIsChecked(e.target.checked);
    if (e.target.checked && data?.length > 0) {
      // Group records by date
      const groupedByDate = data.reduce((acc, record) => {
        const dateKey = record.date?.trim(); // Ensure no leading/trailing spaces
        if (!acc[dateKey]) {
          acc[dateKey] = [];
        }
        acc[dateKey].push(record);
        return acc;
      }, {});

      // Find the latest record per date based on endTime, excluding batches where all endTime values are null
      const latestRecords = Object.values(groupedByDate)
        .map((records) => {
          const validRecords = records.filter((record) => record.endTime); // Filter out records with null endTime
          if (validRecords.length === 0) return null; // If all records in a batch have null endTime, skip batch
          return validRecords.reduce((latest, current) => {
            const latestDate = parseDate(latest.endTime).getTime();
            const currentDate = parseDate(current.endTime).getTime();
            return currentDate > latestDate ? current : latest;
          });
        })
        .filter((record) => record !== null); // Remove null values (batches with all null endTime)

      setData(latestRecords);
    } else {
      getAllDatafromSelectedProject(projectId);
    }
  };

  // finding into all batch last updated value
  // const findLastUpdateRecords = (e) => {
  //   setIsChecked(e.target.checked);
  //   if (e.target.checked && data?.length > 0) {
  //     // Group records by date
  //     const groupedByDate = data.reduce((acc, record) => {
  //       const dateKey = record.date.trim(); // Ensure no leading/trailing spaces
  //       if (!acc[dateKey]) {
  //         acc[dateKey] = [];
  //       }
  //       acc[dateKey].push(record);
  //       return acc;
  //     }, {});

  //     // Find the latest record per date based on endTime
  //     const latestRecords = Object.values(groupedByDate).map(records => {
  //       return records.reduce((latest, current) => {
  //         if (!current.endTime) return latest; // Ignore records with no endTime
  //         if (!latest.endTime) return current; // If latest has no endTime, return current
  //         return new Date(current.endTime) > new Date(latest.endTime) ? current : latest;
  //       });
  //     });

  //     setData(latestRecords);
  //   } else {
  //     getAllDatafromSelectedProject(projectId);
  //   }
  // };

  useEffect(() => {
    getAllDatafromSelectedProject(projectId);
  }, []);

  const setDwgIcon = (status) => {
    if (status === "Stop") {
      return require("../../../Mapi/assets/xls/red.png");
    }
    if (status === "Critical") {
      return require("../../../Mapi/assets/xls/yellow.png");
    }
    if (status === "Report") {
      return require("../../../Mapi/assets/xls/green_new.png");
    }
    if (status === "Pass") {
      return require("../../../Mapi/assets/round.png");
    }
    return require("../../../Mapi/assets/xls/black.png");
  };

  const setDwgReportIcon = (status) => {
    if (status === "Stop") {
      return require("../../../Mapi/assets/dwg/red.png");
    }
    if (status === "Critical") {
      return require("../../../Mapi/assets/dwg/yellow.png");
    }
    if (status === "Report") {
      return require("../../../Mapi/assets/dwg/green_new.png");
    }
    if (status === "Pass") {
      return require("../../../Mapi/assets/round.png");
    }
    return require("../../../Mapi/assets/dwg/black.png");
  };

  const downloadFile = async (rowData, type, ext) => {
    // const response = await handleDownloadClick(fileId, fileName);
    let fileName = "DWGReport_" + generateImageString();

    if (type === "orginialDWG") {
      fileName = rowData.date.trim() + "_" + generateImageString();
    } else if (type === "excel") {
      fileName = "ExcelReport_" + generateImageString();
    }
    resultsFilesDownloadClick(
      generalEndPoint,
      rowData.serialNumber,
      `${fileName + ext}`,
      type
    );
  };

  function onSort(e) {
    let field = e.sortField;
    let order = e.sortOrder;

    // Toggle order if same field clicked again
    if (sortField === field) {
      order = sortOrder === 1 ? -1 : 1;
    } else {
      order = 1; // default to ascending
    }
    let sortedData = sortFields(field, order, data || []);

    setData(sortedData);
    setSortField(field);
    setSortOrder(order);
  }

  return (
    <div className="relative -mt-5 pt-10">
      <MapiToolbar
        onDelete={onDelete}
        onExport={null}
        isLoading={isDeleting}
      />
      <div className="" id="wellcomeDiv">
        <div className="workAreaPageAnimation main-wrap-loader" style={{ minHeight: 'calc(84vh + 8px)' }}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            touched,
            validateForm,
            setTouched,
            resetForm,
          }) => (
            <FormikForm dir="rtl" className="form-wrap-align-between">
              <div
                id="TamarTitleDiv"
                className="d-flex flex-column m-0 overflow-auto"
              >
                <p className="Tamar_Title">פרויקט</p>
                <Row className="customFormRow">
                  {fieldGroups.map((group, colIndex) => (
                    <Col md={4} key={`col-${colIndex}`} className="pr-2 pl-2">
                      {group.map((field, rowIndex) =>
                        field ? (
                          <FormField
                            key={`field-${colIndex}-${rowIndex}`}
                            field={field}
                            errors={errors}
                            touched={touched}
                            fieldDataNew={initialValues}
                          />
                        ) : (
                          <div
                            key={`empty-${colIndex}-${rowIndex}`}
                            className="d-flex align-items-center mb-3 dynamicFormPlaceHolderDiv"
                          />
                        )
                      )}
                    </Col>
                  ))}
                </Row>
                <div className="datatable-doc-demo pt-3" dir="ltr">
                  <div className="card">
                    <DataTable
                      scrollable={data?.length > 7 ? true : false}
                      scrollHeight="43vh"
                      className="p-datatable-projects-v1"
                      onSort={onSort}
                      value={Array.isArray(data) ? data : []}
                      style={{ maxHeight: "430px" }}
                    >
                      {/* <Column
                      style={{ width: "1px" }}
                      field="name"
                      header=""
                      body={(rowData) => <></>}
                    /> */}
                      <Column
                        style={{ width: "auto" }}
                        field="name"
                        header='קישור לתמ"ר שגיאות'
                        body={(rowData) => {
                          return (
                            <div className="column-content-center">
                              {(rowData.dwgFileId != null &&
                                rowData?.dwgFileId != 0) ||
                              rowData.severityStatus ? (
                                <img
                                  src={setDwgReportIcon(rowData.severityStatus)}
                                  width={"30px"}
                                  style={{
                                    cursor:
                                      rowData.severityStatus != "Pass"
                                        ? "pointer"
                                        : "",
                                  }}
                                  onClick={() => {
                                    if (rowData.severityStatus != "Pass") {
                                      downloadFile(rowData, "DWG", ".dwg");
                                    }
                                  }}
                                />
                              ) : (
                                " "
                              )}
                            </div>
                          );
                        }}
                      />

                      <Column
                        style={{ width: "140px" }}
                        field="name"
                        header='דו"ח שגיאות'
                        body={(rowData) => {
                          return (
                            <div className="column-content-center">
                              {rowData?.excelFileId ||
                              rowData.severityStatus ? (
                                <img
                                  src={setDwgIcon(rowData.severityStatus)}
                                  width={"30px"}
                                  style={{
                                    cursor:
                                      rowData.severityStatus != "Pass"
                                        ? "pointer"
                                        : "",
                                  }}
                                  onClick={() => {
                                    if (rowData.severityStatus != "Pass") {
                                      downloadFile(rowData, "excel", ".xlsx");
                                    }
                                  }}
                                />
                              ) : (
                                " "
                              )}
                            </div>
                          );
                        }}
                      />
                      <Column
                        style={{ width: "140px" }}
                        field="name"
                        header='קישור לתמ"ר מקור'
                        body={(rowData) => (
                          <div className="column-content-center">
                            {rowData?.fileId && rowData?.fileId != 0 ? (
                              <img
                                src={require("../../../Mapi/assets/dwg/black.png")}
                                width={"30px"}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  downloadFile(rowData, "orginialDWG", ".dwg");
                                }}
                              />
                            ) : (
                              " "
                            )}
                          </div>
                        )}
                      />

                      <Column
                        field="username"
                        header={
                          <SortableHeader
                            label="שם משתמש"
                            field="username"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={onSort}
                          />
                        }
                        sortable
                      />

                      <Column
                        field="endTime"
                        header={
                          <SortableHeader
                            label="תאריך סיום: שעה"
                            field="endTime"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={onSort}
                          />
                        }
                        sortable
                      />

                      <Column
                        field="startTime"
                        header={
                          <SortableHeader
                            label="תאריך פעולה: שעה"
                            field="startTime"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={onSort}
                          />
                        }
                        sortable
                      />
                      <Column
                        field="actionType"
                        header={
                          <SortableHeader
                            label="סוג פעולה"
                            field="actionType"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={onSort}
                          />
                        }
                        sortable
                      />
                      <Column
                        field="blockNumber"
                        header={
                          <SortableHeader
                            label="מספר גוש"
                            field="blockNumber"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={onSort}
                          />
                        }
                        sortable
                      />
                      <Column
                        field="date"
                        header={
                          <SortableHeader
                            label='תמ"ר'
                            field="date"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={onSort}
                          />
                        }
                        sortable
                      />
                      {/* <Column field="serialNumber" header="מספר סידורי" sortable /> */}
                      <Column
                        field="id"
                        header={
                          <SortableHeader
                            label="#"
                            field="id"
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={onSort}
                          />
                        }
                        style={{ width: "4%" }}
                        sortable
                      />
                    </DataTable>
                  </div>
                </div>
              </div>
              <FormButtons
                values={values}
                preData={preData}
                validateForm={validateForm}
                setTouched={setTouched}
                onClickSubmitForm={onClickSubmitForm}
                onClickCloseForm={onClickCloseForm}
                resetForm={resetForm}
                isChecked={isChecked}
                findLastUpdateRecords={findLastUpdateRecords}
              />
            </FormikForm>
          )}
        </Formik>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailForm;
